import { absolutePath } from "../absolutePath";

export const onboardings = {
  default: () => absolutePath("admin/onboardings/default"),
  show: (id: number) => absolutePath(`admin/onboardings/${id}`),
  profileFields: (id: number) =>
    absolutePath(`admin/onboardings/${id}/profile_fields`),
  update: (id: number) => absolutePath(`admin/onboardings/${id}`),
  updateCustomInvitationEmail: (id: number) =>
    absolutePath(`admin/onboardings/${id}/update_custom_invitation_email`),
  memberChecklistItems: {
    create: (onboardingId: number) =>
      absolutePath(`admin/onboardings/${onboardingId}/member_checklist_items`),
    update: (onboardingId: number, id: number) =>
      absolutePath(
        `admin/onboardings/${onboardingId}/member_checklist_items/${id}`,
      ),
    delete: (onboardingId: number, id: number) =>
      absolutePath(
        `admin/onboardings/${onboardingId}/member_checklist_items/${id}`,
      ),
  },
};
